import { Component, OnInit } from "@angular/core";

import { CategoryChartService } from "../category-chart/service/api/category-chart.service";
import { RegisterBookChartService } from "../charts/services/api/register-book-chart.service";
import { ScheduleBookChartService } from "../charts/services/api/schedule-book-chart.service";
import { ComplainStatusService } from "../complain-chart/service/api/complain-status.service";
import { SessionService } from "./../common/services/session.service";

@Component({
  selector: "app-karyakarta-dashboard",
  templateUrl: "./karyakarta-dashboard.component.html",
  styleUrls: ["./karyakarta-dashboard.component.scss"],
})
export class KaryakartaDashboardComponent implements OnInit {
  officeData: any;
  isVirtualView = false;
  categoryChartData: any;
  complainChartData: any;
  shceduleChartData: any;
  registerChartData: any;

  constructor(
    private readonly session: SessionService,
    private categoryChartAPI: CategoryChartService,
    private complainChartAPI: ComplainStatusService, // public translate: TranslateService, // private sub: SubjectService
    private scheduleChartAPI: ScheduleBookChartService,
    private registerChartAPI: RegisterBookChartService
  ) {
    // this.sub.selectedLang.subscribe((res) => translate.use(res));
  }

  getComplaintCategory() {
    this.categoryChartAPI.getComplainCategoryChartData().subscribe(
      (res: any) => {
        this.categoryChartData = res;
      },
      (err: any) => {}
    );
  }

  getComplaintStatus() {
    this.complainChartAPI.getComplainStatusChartData().subscribe(
      (res: any) => {
        this.complainChartData = res;
      },
      (err: any) => {}
    );
  }

  getScheduleChartData() {
    this.scheduleChartAPI.getScheduleChartData().subscribe(
      (res: any) => {
        this.shceduleChartData = res;
      },
      (err: any) => {}
    );
  }

  getRegisterChartData() {
    this.registerChartAPI.getRegisterChartData().subscribe(
      (res: any) => {
        this.registerChartData = res;
      },
      (err: any) => {}
    );
  }

  ngOnInit() {
    this.isVirtualView = this.session.isVirtualView();
    this.officeData = this.session.getOffice();
    this.getComplaintCategory();
    this.getComplaintStatus();
    this.getScheduleChartData();
    this.getRegisterChartData();
  }
}
